import getAllTableViewsContainingItemsForFolder from '../utils/getAllTableViewsContainingItemsForFolder';
import { TableView } from 'owa-mail-list-store';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import FlagStatus from 'owa-service/lib/contract/FlagStatus';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { mutator } from 'satcheljs';
import flagItemsStoreUpdate from 'owa-mail-actions/lib/triage/flagItemsStoreUpdate';
import { selectMailStoreItemById } from 'owa-mail-store';

export default mutator(flagItemsStoreUpdate, actionMessage => {
    // Need to check all tables for the given folder
    const tableViews = getAllTableViewsContainingItemsForFolder(
        actionMessage.parentFolderId,
        true /* shouldIncludeSearchTable */
    );

    for (const tableView of tableViews) {
        // We only care about updating roll up status in conversation table
        // Item level updates are handled separately in mail store mutator
        if (tableView.tableQuery.listViewType == ReactListViewType.Conversation) {
            for (const itemId of actionMessage.itemIds) {
                rollupFlagStatusChangeOnConversation(
                    itemId,
                    tableView,
                    actionMessage.flagTypeToSet.FlagStatus
                );
            }
        }
    }
});

function rollupFlagStatusChangeOnConversation(
    itemId: string,
    tableView: TableView,
    flagStatusToSet: FlagStatus
) {
    const item = selectMailStoreItemById(itemId);
    const rowKeys = getRowKeysFromRowIds([item.ConversationId.Id], tableView);
    for (const rowKey of rowKeys) {
        const tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);

        // Roll up the update to the conversation. Some notes here:
        // 1. If the conversation was not flagged and a local item in it was flagged,
        // we know the conversation should be flagged.
        // 2. If the conversation was flagged and a local item in it was unflagged,
        // we cannot know for certain that the conversation doesn't have any more local
        // flagged items. However, this is the most common case, so we'll optimistically clear the
        // flag status on the conversation. If we were wrong, notifications will correct us
        tableConversationRelation.flagStatus = flagStatusToSet;
    }
}
